import React, { useState } from 'react';
import { signInWithEmailAndPassword } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../../../services/firebase";
import Swal from 'sweetalert2';
import './AdminSignIn.css';
import Navbar from '../../Navbar/Navbar';
import SideImage from '../../SideImg/SideImg';
import AuthBanner from '../../../assets/signupuserbanner.png';
import { useNavigate } from 'react-router-dom';

const AdminSignIn = () => {
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.email) newErrors.email = 'Email is required';
        if (!formData.password) newErrors.password = 'Password is required';
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleAdminEmailSignIn = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setIsLoading(true);
        try {
            const userCredential = await signInWithEmailAndPassword(auth, formData.email, formData.password);
            const user = userCredential.user;

            // Get the user's role from the `admins` collection
            const userDoc = await getDoc(doc(db, "admins", user.uid));

            if (!userDoc.exists()) {
                // If the user's record is not in the admins collection, it's not an admin.
                await auth.signOut(); // Log them out immediately
                throw new Error("Access denied. You are not authorized as an admin.");
            }

            const userData = userDoc.data();
            if (userData.role !== "admin") {
                await auth.signOut(); // Log them out if role is not "admin"
                throw new Error("Access denied. You are not authorized as an admin.");
            }

            // Passed all checks
            Swal.fire({
                title: 'Success!',
                text: 'You have successfully signed in as Admin.',
                icon: 'success'
            }).then(() => {
                navigate('/admin');
            });

        } catch (error) {
            console.error("Sign in error:", error);
            let errorMessage = "Sign in failed. Please try again.";

            switch(error.code) {
                case 'auth/invalid-email':
                    errorMessage = "Please enter a valid email address.";
                    break;
                case 'auth/user-not-found':
                    errorMessage = "No account found with this email.";
                    break;
                case 'auth/wrong-password':
                    errorMessage = "Incorrect password. Please try again.";
                    break;
                case 'auth/too-many-requests':
                    errorMessage = "Too many attempts. Please try again later.";
                    break;
                default:
                    errorMessage = error.message || errorMessage;
                    break;
            }

            Swal.fire("Error", errorMessage, "error");
        } finally {
            setIsLoading(false);
        }
    };



  return (
    <div className='page__wrapper'>
      <Navbar />
      <div className='auth__container'>
        <SideImage sideBannerSrc={AuthBanner} sideBannerAlt={"Alex Menswear Auth Banner"} />
        <div className="sign-in-container">
          <div className="sign-in-box">
            <div className="signin-header">
              <h1>Admin Sign In</h1>
              <p>Log into your admin account to have access to a personalized experience.</p>
            </div>

            <form className="sign-in-form" onSubmit={handleAdminEmailSignIn}>
              <input
                type="email"
                name="email"
                placeholder="Email Address" 
                className={`sign-in-input ${errors.email ? 'input-error' : ''}`}
                autoComplete="username"
                value={formData.email}
                onChange={handleChange}
              />
              {errors.email && <span className="error-message">{errors.email}</span>}
              
              <input
                type="password"
                name="password"
                placeholder="Password"
                className={`sign-in-input ${errors.password ? 'input-error' : ''}`}
                autoComplete="current-password"
                value={formData.password}
                onChange={handleChange}
              />
              {errors.password && <span className="error-message">{errors.password}</span>}
              
              <button 
                type="submit" 
                className="sign-in-button"
                disabled={isLoading}
              >
                {isLoading ? 'Signing In...' : 'Log In'}
              </button>
            </form>

            <div className="sign-in-links">
              <p>Don't have an Account? <a href="mailto:alexmenswear@yahoo.com">Contact Support</a></p>
              <a href="/forgot-password">Forgot your password?</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminSignIn;